import { ColorTypes, TextSizes } from '@afterpaytouch/core'
import { Money as MoneyValue, SupportedLocale } from '@afterpay/types'

export interface MoneyProps {
  value?: MoneyValue | null
  size?: TextSizes
  strikethrough?: boolean
  bold?: boolean
  showFree?: boolean
  loading?: boolean
  color?: ColorTypes | 'IGNORE'
  locale?: SupportedLocale
  testNameSpace?: string
  mintBar?: boolean
  decimalPlaces?: number
  prefix?: MoneyPrefix
  showAsterisk?: boolean
}

export enum MoneyPrefix {
  POSITIVE = '+',
  NEGATIVE = '-',
  NONE = '',
}
